/**
 * Main Menu
 */
;(function($) {
	// Accesible toggle menu
	$('#nav-primary').accessibleMegaMenu({
		uuidPrefix: 'amenu',
		menuClass: 'amenu__main',
		topNavItemClass: 'amenu__top',
		panelClass: 'amenu__panel',
		panelGroupClass: 'sub-menu',
		hoverClass: 'hover',
		focusClass: 'focus',
		openClass: 'open',
	})
	// Regular WordPress Menu
	$('.menu-footer-container').accessibleMegaMenu({
		uuidPrefix: 'amenu',
		menuClass: 'menu',
		topNavItemClass: 'menu__top',
		panelClass: 'menu__panel',
		panelGroupClass: 'sub-menu',
		hoverClass: 'hover',
		focusClass: 'focus',
		openClass: 'open',
	})

	let $currentLang = $('html').attr('lang')
	if ($currentLang === 'fr-FR') {
		$('#menu-item-60').addClass('current-menu-item')
	} else {
		$('#menu-item-59').addClass('current-menu-item')
	}
})(jQuery)
